import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div``

export const ContainerInput = styled.div`
  display: flex;
  flex-direction: row;
  input {
    width: 100%;
    height: 40px;
    font: normal normal normal 16px/15px Inter;
    color: ${props => props.theme.colors.color6b7786};
    padding: 10px 16px 10px 16px;
    background: ${({ theme }) => theme.zds.colors.neutral1000};
    border: 1px solid ${props => props.theme.colors.colordfe3e8};
    border-right: none;
    border-radius: 0 0 4px 4px;
  }
  ::placeholder {
    color: ${props => props.theme.colors.color6b7786};
  }
`
export const ContainerIcon = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 16px 10px 16px;
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  border: 1px solid ${props => props.theme.colors.colordfe3e8};
  border-left: none;
  border-radius: 4px 4px 0 0;
  cursor: pointer;

  svg: hover {
    fill: #378ff6;
  }
`
export const ContainerListOptions = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  position: absolute;
  z-index: 12;
  width: 100%;
  padding: 8px 0;
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  border: 1px solid ${props => props.theme.colors.colordfe3e8};
  border-top: none;
  border-radius: 0px 4px 4px 0;
  max-width: -webkit-fill-available;

  ul {
    margin-top: 10px;
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: 100px;

    ${VerticalStyledScrollBar}
  }

  p {
    font-size: 14px;
    font-family: 'Inter';
    color: ${props => props.theme.colors.color5a6a7e};
    background: ${({ theme }) => theme.zds.colors.neutral1000};
    padding: 5px 16px 5px 16px;

    strong {
      font-size: 14px;
      font-family: 'Inter';
      font-weight: 600;
      color: ${props => props.theme.colors.color2d3139};
    }
  }
`

export const Option = styled.button`
  width: 100%;
  padding: 4px 16px 4px 16px;

  font-size: 1rem;
  line-height: 1.25rem;
  font-family: 'Inter';
  color: ${props => props.theme.colors.color2d3139};
  text-align: start;

  border: none;
  cursor: pointer;
  background: ${({ theme }) => theme.zds.colors.neutral1000};

  strong {
    font-weight: 600;
  }

  &:hover {
    background: ${props => props.theme.colors.colorf5f8fa};
  }
`
